<template>
<div>
        <!-- <v-container fluid>
          <v-layout row wrap> -->
            <!-- <v-flex xs12 sm12> -->
              <!-- {{e_input}}    -->
              <v-autocomplete
                v-bind="$attrs"
                v-model="e11"
                :search-input.sync="e_input"
                @click:append="test"
                multiple
                chips
                deletable-chips
                auto-select-first
                :items="optionItems"
                item-text="S2TypeName"
                item-value="S2TypeCode"
                clearable
                :menu-props="mProp"
              ></v-autocomplete>
                 
            <!-- </v-flex> -->
          <!-- </v-layout>
        </v-container> -->
</div>
</template>
<script>
  import itisoServ from '@/store/api/services/itisoService'
  export default {
    props: {
      // rules: {
      //   type: Array
      // },
      value: {
        type: String,
        default: ''
      },
      filter: {
        type: String,
        default: ''
      },
      S2TypeCode: {
        type: String,
        default: ''
      },
      single: {
        type: Boolean,
        default: false
      },
      // label: {
      //   type: String,
      //   default: ''
      // },
      // readonly: {
      //   type: Boolean,
      //   default: false
      // }
    },
    mounted: function () {
      this.formatValue()
      this.$nextTick(async function () {
        console.log('created', this.$route.params.id)
        let response = await this.getDB({GroupName:this.filter})
        if (response.data.error === '') {
          this.optionItems = response.data.data
        } else {
          console.log('Error')
          this.optionItems = [{S2TypeCode:'',S2TypeName:response.data.error}]
        }
        
        if (this.$store.state.users.empAll.length === 0){
          // console.log('inputperson dispacth getEmpAll')
          // this.optionItems = this.$store.state.dispacth('getS2TypeCode')
          
        } else {
          // console.log('inputperson users.empAll')
          // this.optionItems = this.$store.state.users.empAll
        }
        if (this.filter !== '') {
          // console.log('inputperson filter',this.optionItems)
          this.optionItems = this.optionItems.filter((e) => {
            if( eval(this.filter) ) {
              // filter = 'e.DepCode === "สารสนเทศ"'
              // filter = 'e.DivName === "ฝ่ายบริหาร"'
              console.log(this.filter,eval('e.DepCode'))
              return e
            }
          })
        }
      })
    },
    watch: {
      async filter() {
        console.log('filter change')
        
        if (this.filter !== '') {
          console.log('inputperson filter',this.optionItems)
          let response = await this.getDB({GroupName:this.filter})
          if (response.data.error === '') {
            this.optionItems = response.data.data
          } else {
            console.log('Error')
            this.optionItems = [{S2TypeCode:'',S2TypeName:response.data.error}]
          }
        }
      },
      value () {
        // console.log('value', this.value)
        if (this.value) {
          // console.log('input value 1', this.value)
          // console.log('input e11', this.e11)
          var v
          if (this.value !== '') {
            v = this.value.split(',')
          } else {
            v = []
          }
          // console.log('input v ', v)
          if(this.single && v.length > 1) {
            v.shift()
          }
          if (v !== this.e11) {
            this.e11 = v
            this.$emit('input', this.e11.toString())
          }
        } else {
          this.e11 = []
          this.$emit('input', '')
        }
        this.e_input = ''
      },
      e11 () {
          // console.log('e11', this.e11)
          this.$emit('input', this.e11.toString())
      }
    },
    computed: {
      items: function() {
        return this.data.optionItems
      }
    },
    methods: {
      async getDB(filter) {
        filter.sortBy = 'flag asc'
        let res = await itisoServ.s2typeListByParam(filter)
        return res
      },
      test: function() {
        console.log('update:search-input')
      },
      formatValue: function () {
        // console.log('label', this.label)
        // console.log('formatValue-01', this.value)
        if (this.value) {
          this.e11 = this.value.split(',')
        } else {
          this.e11 = []
        }

        // this.formatted = this.Date2Text(this.value)
        // this.$refs.Input.value = this.Date2Text(this.value)
        // console.log('formatValue-03  ok', this.e11)
      },
      getName: function (code) {
        return this.optionItems.filter((p) => {
          if (p.code === code) return p
        })[0]
      }

    },
    data () {
      return {
        mProp:{
          maxHeight: 250,
        },
        e11: [],
        e_input:'',
        picPath: '/static/doc-images/lists/',
        optionItems: [
          { header: 'Group 1' },
          { S2TypeCode: '0090', S2TypeName: 'Sandra Adams', ListName: 'ListName 1' },
          { S2TypeCode: '0091', S2TypeName: 'Ali Connors', ListName: 'ListName 1' },
          { S2TypeCode: '0092', S2TypeName: 'Trevor Hansen', ListName: 'ListName 1' },
          { S2TypeCode: '0093', S2TypeName: 'Tucker Smith', ListName: 'ListName 1' },
          { divider: true },
          { header: 'Group 2' },
          { S2TypeCode: '0094', S2TypeName: 'Britta Holt', ListName: 'ListName 2' },
          { S2TypeCode: '0095', S2TypeName: 'Jane Smith ', ListName: 'ListName 2' },
          { S2TypeCode: '0096', S2TypeName: 'John Smith', ListName: 'ListName 2' },
          { S2TypeCode: '0097', S2TypeName: 'Sandra Williams', ListName: 'ListName 2' }
        ]
      }
    }
  }
</script>
<style scoped>
  .v-text-field {
    margin-top: 2px;
    padding-top: 4px;
  }

  /* .list__tile .list__tile--active a {
    color:#fff;
    background-color: blue;
  }
  div .list__tile--active {
    background-color: blue;
  } */
  /* list__tile--avatar list__tile--active list__tile--highlighted" */
</style>
